export default {
  cName: "创新能商户平台",
  last24hours: "近24小时",
  last7days: "近7天",
  last30days: "近30天",
  custom: "自定义",
  multiple: "多选",
  exportEdit: "导出",
  getCode: "获取验证码",
  enterPhoneFormat: "请输入正确的手机号",
  sentSuccessfully: "发送成功",
  resend: "再次发送",
  setPower: "设置功率",
  powerPl: "请输入功率",
  successfullySet: "设置成功",
  rechargeSuccess: "充值成功",
  sysTitle: "商户平台",
  operatorId: "运营商代码",
  oprName: "运营商名称",
  tips: "提示",
  isDelete: "是否确认删除",
  deleteSuccess: "删除成功",
  updateSuccess: "修改成功",
  addSuccess: "新增成功",
  all: "全部",
  operation: "操作",
  dl: "电量",
  eleFee: "电费",
  serverFee: "服务费",
  delayFee: "占桩费",
  totalAmount: "总金额",
  yuan: "THB",
  kWh: "度",
  unitOrder: "单",
  ac: "交流",
  dc: "直流",
  confirm: "确认",
  noData: "暂无数据",
  allCity: "全部城市",
  chargingStation: "充电站",
  merchant: "商户",
  operator: "运营商",
  chargingPile: "充电桩",
  year: "年",
  month: "月",
  day: "日",
  timeType: "类型",
  regularText: "正常",
  irregular: "异常",
  operationSucess: "操作成功",
  saveSucess: "保存成功",
  exportSuccess: "导入成功",
  allSelect: "全选",
  toExamine: "审核",
  invalid: "作废",
  accountBalance: "账户余额",
  today: "本日",
  thisWeek: "本周",
  thisMouth: "本月",
  regular: {
    name: "名称",
    please: "请输入",
    max: "不能超过",
    maxText: "个字符",
    min: "不能少于",
    numberABC: "只能由数字或者字母组成",
    number_ABC: "只能由数字+字母+下划线组成",
    tel: "请输入手机号码或者座机号码，6-15位",
    phone: "请输入电话",
    phonePl: "请输入手机号码",
    phonePl11: "请输入11位数字的手机号码",
    phoneError: "请输入正确格式的手机号码",
    int: "只能是整数数字",
    maxInput: "最多输入",
    minInput: "最少输入",
    unit: "位",
    maxNum: "不能大于",
    minNum: "不能小于",
    money: "金额",
    towDecimal: "最多保留两位小数",
    email: "请输入邮箱",
    emailPl: "邮箱不能超过",
    emailError: "请填写正确的邮箱",
    passwordTips1: "字符限制12~18位",
    passwordTips2:
      "必须包含大写字母、小写字母、数字和特殊字符, '!',  '#', '$', '%', '&'"
  },
  unitText: {
    pen: "笔",
    yuan: "THB",
    hours: "时",
    people: "人",
    seat: "座",
    k: "k",
    kYuan: "k THB",
    kKWh: "k kWh",
    kKW: "k kW",
    year: "年",
    month: "月",
    day: "日",
    ton: "吨",
    second: "次",
    full: "满",
    reduce: "减",
    give: "送",
    zhang: "张",
    individual: "个"
  },
  formText: {
    startTime: "开始时间",
    endTime: "结束时间",
    export: "导出",
    exportLoading: "导出中...",
    exportNumber: "导出条数",
    exportPl: "导出条数须大于0",
    exportError: "导出出错或者超时",
    allCity: "全部城市",
    selectGun: "充电枪",
    selectMch: "商户",
    selectSite: "充电站",
    selectPile: "充电桩",
    selectTime: "选择时间",
    selectTimePl: "请选择时间",
    selectOper: "运营商",
    downloadForm: "下载表格",
    intTips: "数值",
    beginTimeTips: "请选择开始时间",
    endTimeTips: "请选择结束时间",
    import: "导入",
    selectProvince: "请选择省",
    selectCity: "请选择市",
    selectArea: "请选择区",
    subSuccess: "操作成功",
    goBack: "返回",
    timeNull: "请选择时间",
    timeMax: "开始时间不能超过结束时间"
  },
  directCurrent: "直流",
  alternatingCurrent: "交流",
  gunStatus: "枪口状态",
  gunStatusObj: {
    onLine: "在线",
    offLine: "离线",
    free: "空闲",
    connected: "插枪",
    charging: "充电",
    full: "充满",
    trouble: "故障",
    disabled: "禁用",
    booked: "预约"
  },
  search: "查询",
  update: "编辑",
  add: "新增",
  delete: "删除",
  close: "关闭",
  save: "保存",
  refresh: "刷新",
  back: "返回",
  export: "导出",
  import: "导入",
  submit: "提交",
  cancel: "取消",
  details: "详情",
  safePassword: {
    title: "请输入操作密码，确认此项操作无误",
    password: "密码",
    noPassword: "忘记密码？",
    passwordPl: "请输入密码"
  },
  login: {
    contentTitle: "为美好生活充电",
    contentTitleSmall: "接入开放平台，互联生态一目了然",
    account: "账号登录",
    userNamePl: "请输入用户名",
    passwordPl: "请输入密码",
    passwordMax: "请输入6位以上的密码",
    userName: "用户名",
    password: "密码",
    login: "登录",
    accountTime: "账号将在",
    accountTime2: "天后失效，失效后将无法登录系统",
    mchSys: "商户平台",
    changeLangPl: "请选择语言"
  },
  home: {
    todayOrder: "订单量",
    todayDl: "充电量",
    todayRevenue: "今日营收（THB）",
    gunStatus: "充电枪状态",
    yesterdayOrder: "昨日订单情况",
    todayDlTime: "今日 00:00-24:00 的充电电量（度）",
    todayOrderTime: "今日 00:00-24:00 创建的订单量（单）",
    assetTitle: "资产信息",
    siteNum: "站点统计",
    pileNum: "电桩统计",
    gunNum: "枪口统计",
    dcNum: "直流口",
    acNum: "交流口",
    totalPower: "总功率（kW）",
    dcPower: "直流桩功率",
    acPower: "交流桩功率",
    settlementTitle: "结算信息",
    dailyDtatement: "未结算日结单",
    withdrawalForm: "未付款提现单",
    undrawnAmount: "正在付款金额",
    withdrawnAmount: "已付款金额",
    revenueTitle: "营收统计",
    totalRevenue: "收入金额总计（THB）",
    onlineChargingSharing: "线上充电分成（THB）",
    offlineChargingSharing: "线下充电分成（THB）",
    yesterdayRanking: "昨日电桩利用率排名",
    pile: "电桩",
    utilizationRate: "利用率",
    order: "订单（笔）",
    total: "总数",
    hour: "时"
  },
  nonCard: {
    cardMember: "充电卡数量",
    cardMemberStatis: "充电卡状态数量",
    memberTypeNum: "会员类型数量",
    member: "会员",
    nonMember: "非会员",
    use: "使用中",
    logOff: "已注销",
    recharged: "已充值（THB）",
    charged: "已充电（THB）",
    globalSearch: "流水号/电卡会员号",
    cardStatis: "电卡状态",
    activation: "激活",
    unactivated: "未激活",
    disabled: "停用",
    expired: "失效",
    normal: "正常",
    logOffBtn: "注销",
    delete: "删除",
    rechargedBtn: "充值",
    refundBtn: "退款",
    operationRecord: "操作记录",
    capitalRecord: "资金记录",
    thisYear: "今年",
    accountPkId: "电卡会员号",
    cardPhysicalNumber: "电卡序号",
    memberType: "会员类型",
    name: "名称",
    email: "邮箱",
    validity: "有效期",
    cardSerialNumber: "流水号",
    silkScreenNumber: "丝印编号",
    contactName: "联系名",
    phoneNo: "联系电话",
    accountBalance: "卡内余额（THB）",
    cardStatus: "电卡状态",
    createTime: "开卡时间",
    cardPkId: "卡号",
    remarks: "备注",
    rechargeAmount: "充值金额",
    selectMemberType: "选择会员卡类型",
    NIK: "身份证号",
    validPeriodSelection: "有效期选择",
    chargingHours: "充电时长",
    chargingHoursTip: "每天充电时长限制",
    saveOnly: "仅保存",
    keepAndActivate: "保持并激活",
    verCode: "验证码"
  },
  nonFundHistory: {
    rechargedTab: "充值",
    chargedTab: "充电",
    staName: "站点名称",
    chargeBeginTime: "开始时间",
    chargeEndTime: "结束时间",
    chargeMinutes: "充电时长",
    chargeElect: "充电量（kWh）",
    delayAmount: "占桩费（THB）",
    delayDuration: "占桩时长",
    chargeAmount: "充电费用（THB）",
    beforeBalance: "交易前余额（THB）",
    afterBalance: "交易后余额（THB）",
    orderNo: "订单号",
    transactionTime: "充值时间",
    rechargeAmount: "金额（THB）",
    createName: "操作人",
    refundTime: "申请退款时间",
    refundAmount: "申请退款金额（THB）",
    refundedAmount: "成功退款金额（THB）",
    refundResultDesc: "退款进度",
    time: "时间"
  },
  cancellation: {
    cardSerialNumber: "流水号",
    accountBalance: "金额",
    tips: "注销后,卡内金额将自动全额退款，充电卡将无法使用",
    success: "注销成功",
    successConfirm: "确定要注销吗?"
  },
  nonCardDetails: {
    cardInfo: "电卡信息",
    remark: "备注",
    accountBalance: "账户余额（THB）",
    createUserName: "开卡人",
    createTime: "开卡时间",
    statusDesc: "电卡状态"
  },
  nonRealNameCardManagement: {
    cardMember: "电卡会员（人）",
    cardStatus: "电卡状态",
    inUse: "使用中",
    cancelled: "已注销",
    operationStatistics: "归属统计",
    selfSupport: "运营商自营",
    generationCamp: "代营商户",
    fuzzySearch: "流水号/电卡会员号/联系人/联系电话",
    cardAffiliation: "卡片归属",
    commercialTenant: "商户",
    cardNumber: "电卡会员号",
    cardPhysicalNumber: "电卡序号",
    cardSerialNumber: "流水号",
    contacts: "联系人",
    phone: "联系电话",
    cardBalance: "卡内余额（THB）",
    frozenAmount: "冻结金额（THB）",
    openTime: "开卡时间",
    remark: "备注",
    money: "开卡金额",
    openCardTips: "请保持发卡器与电脑正常连接，并将卡片放置于发卡器上",
    openCardError: "该充电卡已被使用，请更换卡片",
    cardPhysicalNumberPl: "请输入电卡序号",
    cardSerialNumberPl: "请输入流水号",
    moneyPl: "请输入充值金额",
    moneyMax: "单次充值金额不能多于 5000",
    moneyMin: "单次充值金额不能少于 0",
    moneyError: "开卡金额必须为数字，且小数位不超过两位",
    openCardSuccess: "开卡成功",
    balance: "余额",
    amount: "金额",
    cancellation: "注销",
    cancellationTips: "注销后卡内金额将自动全额退款，充电卡将无法使用",
    cancellationSuccess: "注销成功",
    accountBalance: "账户余额（THB）",
    createUserName: "开卡人",
    createTime: "开卡时间",
    status: "电卡状态",
    operationInfo: "操作信息",
    cardInfo: "电卡信息",
    cardDetails: "非实名卡详情",
    remarkPl: "请输入备注",
    createName: "操作人",
    operateTime: "操作时间",
    operateType: "操作",
    rechargeAmount: "充值金额（THB）：",
    allMoneyMax: "在线卡最大金额不能超过 9999 THB",
    accountPkId: "会员卡号",
    refundAmount: "退款金额（THB）",
    refundBtn: "退款",
    refundError: "退款金额不能超过账户余额",
    refundSuccess: "退款成功",
    silkScreenNumber: "丝印编号",
    getCard: "读卡",
    input: "直接录入",
    reset: "重置",
    cardExist: "卡已存在，请先注销或者换一张卡再执行开卡操作",
    openCard: "开卡",
    silkScreenNumberPl: "请输入丝印编号",
    contactsPl: "请输入联系人",
    cardYes: "可对此卡进行操作",
    logout: "销卡",
    viewNo: "您的浏览器不支持发卡系统",
    connectError: "发卡器连接失败",
    logoutSuccess: "销卡成功",
    cardChange: "卡片已更换，请重新读卡",
    cardWhite: "此卡是空白卡，请先开卡",
    statusError1: "请先读卡再操作",
    statusError2: "未检测到充电卡，请重试",
    statusError3: "客户编码不能为空",
    statusError4: "卡类型不能为空",
    statusError5: "ID不能为空",
    statusError6: "卡ID 只能是 16 位数字",
    statusError7: "非本系统卡，无法操作！",
    logoutTitle: "此操作将删除此卡的所有信息，请谨慎操作",
    connectBtn: "连接发卡器",
    connectBtnLoading: "正在连接发卡器……",
    cardBind: "此卡已使用，请换一张未使用过的卡片，流水号: ",
    relation: "关联",
    userName: "会员名称",
    cardNumberPl: "请输入卡号",
    relationSuccess: "关联成功",
    hasSms: "是否发送短信",
    hasSmsPl: "请选择是否发送短信",
    word: "温馨提示：操作使用说明文档",
    wordDownload: "点击此处下载",
    no: "否",
    yes: "是",
    cardConnectionFailed: "发卡器连接失败",
    notSupport: "您的浏览器不支持发卡系统"
  },
  cardTips: {
    t1: "1. 下载并安装发卡器驱动",
    download: "点击此处下载",
    t1_1: "如为 Windows XP 系统，请",
    t2:
      "2. 将读卡器通过USB线连接计算机，正常上电后读卡器会'哔'一声并保持读卡器内部LED灯闪。",
    t3: "3.下载并运行发卡器插件（",
    t3_1: "），连接读卡器之后点击“开启服务”即可。",
    t4: "4. 打开浏览器的发卡管理进行相关操作。",
    tips: "注意事项：",
    tips1: "1. 目前支持 Windows 操作系统，Windows 7/10 各系列版本。",
    tips1_1: "如要在 Windows XP 系统下使用需要安装 .net3.5 框架",
    tips2: "2. 运行过程中必须确保发卡器插件持续开启服务状态。",
    tips3:
      " 3. 提示“检查是否插入读卡器或是否安装串口驱动”时，一般是没有插上读卡器或者串口驱动未安装的问题，右键“我的电脑” 选择 “管理” ，再弹出的 “计算机管理” 窗口中，点击左边菜单的“设备管理器” 后，查看 “其它设备” 下是否存在 “USB Serial Port” 或 “FT232RUSR UART”。如果没有，说明读卡器没插上，换个USB口试一试。"
  },
  addMerchant: {
    accountInfo: "账号信息",
    info: "基本信息",
    fullName: "商户名称",
    shortName: "商户简称",
    contacts: "联系人",
    contactsMail: "联系邮箱",
    telephone: "联系电话",
    address: "联系地址",
    operatorShare: "运营商分成",
    shareType: "分成类型",
    isMoneyRules: "固定金额",
    isMoneyRulesShareMaxError: "固定金额分成不能大于总金额",
    orderTotalMoney: "单笔订单总金额",
    orderTotalMoneyMax: "THB以上",
    orderShare: "每笔订单分成",
    isMoneyRulesTips:
      "根据分成类型显示对应分成金额配置，可进行多选。\n\n注：选择固定金额后，每笔订单不能同时选择总金额分成",
    isPercentageRules: "百分比",
    order: "每笔订单",
    cashConfig: "提现配置",
    cashMin: "最低提现金额",
    condition: "条件",
    fromValueTips: "结算金额满",
    feeTips: "扣除转账手续费",
    feeTipsPl: "扣除转账手续费百分比",
    loginUrl: "登录地址",
    addTitle: "新增账号",
    resetPassword: "重置密码",
    mchCollectionInfo: "商户收款信息",
    bankAccountName: "银行账户名称",
    bankDeposit: "收款账户开户银行",
    bankAccountNo: "收款银行账户",
    addMch: "新增商户",
    loginTitle: "新增登录账号",
    updataTitle: "修改登录账号",
    required: "必填项",
    textLenMax: "长度不能超过",
    divisionPercentPl: "请选择分成方式",
    divisionPercentMax: "值区间：0.00~100",
    divisionPercentError: "请输入有效数字",
    base2: "百分比",
    minWithdrawAmount: "最低提现金额",
    bankDepositPl: "请输入收款账户开户银行",
    bankAccountNamePl: "请输入收款账户名称",
    userName: "登录用户名",
    effectiveTime: "生效时间",
    expireTime: "过期时间",
    accountName: "账户名称",
    bankInstitutionDesc: "银行机构",
    remarks: "备注",
    delConfig: "确定要删除当前账号吗？",
    userParamsNull: "登录用户账户不能为空",
    isPercentageRulesPl: "请选择百分比分成的类型",
    isPercentageRulesError: "百分比分成的类型不能重复",
    addSuccess: "新增成功",
    mchLoginInfo: "商户登录信息",
    userParamsMax: "只能存在一个登录用户，请删除多余的",
    mchDetails: "商户详情",
    upDetails: "修改商户",
    add: "添加",
    rolePkIdPl: "请选择角色",
    expireTimePl: "请先选择生效日期",
    expireTimeError: "不能早于生效日期",
    userNameError: "用户名重复",
    issueCardCode: "客户编码",
    userPwd: "密码",
    confirmPassword: "确认密码",
    amountType: "每笔订单电费",
    amountType2: "每笔订单服务费",
    amountType3: "每笔订单占桩费",
    cooperationTime: "合作截止日期",
    currentPassword: "当前密码"
  },
  upSafePassword: {
    userPwd: "新密码",
    confirmPassword: "再次输入新密码",
    verCode: "手机验证码",
    verCodePl: "验证码不能为空",
    userPwdPl: "密码不能为空",
    userPwdLen: "密码长度为 6~18",
    userPwdError: "密码不能包含空格、制表符、换行符",
    confirmPasswordPl: "确认密码不能为空",
    confirmPasswordError: "密码不一致",
    upError: "修改失败",
    upSuccess: "修改密码成功，请重新登录"
  },
  commonTableName: {
    cardNo: "卡号",
    insideOrderNo: "交易编号",
    externalOrderNo: "外部订单号",
    orderStatus: "订单状态",
    orderType: "订单类型",
    no: "否",
    yes: "是",
    details: "详情",
    endOrder: "结束订单",
    error: "异常处理",
    orderNo: "订单号",
    merchantName: "商户名称",
    netSystemName: "合作运营商",
    orderStatusDesc: "订单状态",
    staName: "站点名称",
    pileName: "桩名称",
    gunName: "枪名称",
    serialNumber: "桩编号",
    memberName: "会员名",
    phoneNo: "手机号",
    carNo: "车牌号",
    chargeBeginTime: "开始充电时间",
    chargeEndTime: "结束充电时间",
    payTime: "支付时间",
    chargeDuration: "充电时长",
    delayDuration: "占桩时长",
    chargeElect: "电量（kWh）",
    connectionfee: "连接费（THB）",
    chargeAmount: "电费（THB）",
    serviceAmount: "服务费（THB）",
    time: "时间段",
    delayAmount: "占桩费（THB）",
    totalAmount: "消费总金额（THB）",
    discountAmount: "总金额优惠（THB）",
    transactionAmount: "实付金额（THB）",
    startSoc: "开始 soc",
    endSoc: "结束 soc",
    stopReason: "停止原因",
    orderSource: "订单来源",
    abnormalType: "是否异常",
    elecPrice: "电费费率（THB/kWh）",
    servicePrice: "服务费率（THB/kWh）",
    slotFlag: "电价类型",
    slotElecPrice: "电价（THB）",
    delayMins: "时长（分钟）",
    delayFreeMins: "免费时长（分钟）",
    sex: "性别",
    vipType: "会员类型",
    vin: "VIN 码",
    cardType: "车型",
    staType: "站点类型",
    staStatus: "站点状态",
    staAddr: "充电站地址",
    gunPkId: "枪编号",
    manufacturer: "归属厂商",
    deviceType: "电桩类型",
    devicemodel: "设备型号",
    ratedPower: "额定功率",
    ratedCurrent: "额定电流",
    ratedVoltage: "额定电压",
    timeInterval: "时段",
    chargeDiscount: "电费优惠",
    serviceDiscount: "服务费优惠",
    delayDiscount: "占桩费优惠",
    totalDiscount: "优惠总金额",
    chargeTransAmount: "实付电费（THB）",
    serviceTransAmount: "实付服务费（THB）",
    jian: "尖",
    feng: "峰",
    ping: "平",
    gu: "谷",
    beforeBalance: "消费前金额（THB）",
    afterBalance: "消费后金额（THB）",
    reteInfo: "电桩费率信息",
    charge: "充电次数（次）",
    startTime: "开始时间",
    endTime: "结束时间",
    modifyTime: "更新时间",
    staPkId: "站点编号",
    entUserName: "企业名称",
    chargingCard: "用户卡号",
    chargingMode: "充电方式",
    userType: "用户类型",
    stationRegion: "站点区域",
    cardNameOrMemberName: "充电卡名称/联系人名称",
    memberType: "会员类型"
  },
  orderList: {
    orderSource1: "线上订单",
    orderSource2: "线下订单",
    exportType: "默认",
    exportType2: "详情",
    end: "已结束充电",
    endConfirm: "确定要结束该订单吗?",
    endLoadingTips: "下发停止充电命令",
    endLoadingTips2:
      "系统将给充电桩下达停止充电命令，若 15s 内订单状态无法变更为“充电完成”，将继续进行第 2 步操作",
    endLoadingTips3: "生成平台充电报告",
    endLoadingTips4:
      "系统将给充电桩推送平台充电报告，若 15s 内订单状态无法变更为“充电完成”，将继续进行第 3 步操作",
    endLoadingTips5: "修改订单状态为异常单",
    endLoadingTips6: "系统将修改此订单为异常单，用户可正常进行下一次的充电操作",
    endLoading: "处理中..",
    endCharge: "结束充电",
    loadingSuccess: "下发停止命令成功",
    success: "生成平台报告成功",
    orderError: "订单状态已变更为异常",
    endSuccess: "结束成功",
    pageTitle: "充电订单",
    totalChargeElect: "总充电量（kWh）",
    totalTransactionAmount: "实际总收入（THB）",
    totalServiceAmount: "服务费（THB）",
    totalChargeAmount: "电费（THB）",
    totalDelayAmount: "占桩费（THB）",
    totalDiscount: "总金额优惠（THB）",
    totalServiceDiscount: "服务费优惠（THB）",
    totalChargeDiscount: "电费优惠（THB）"
  },
  abnormalOrder: {
    pileCharging: "桩计费（THB）",
    chargeTime: "充电时段",
    stopReason: "停止原因",
    pileChargeAmount: "桩充电费总额（THB）",
    sysCharging: "平台计费（THB）",
    sysChargeAmount: "平台充电费总额（THB）",
    pileErrorValue: "与桩误差值：",
    normalErrorValue: "正常误差值：差值小于 0.5THB 或差值比例小于 20%",
    usePileCharging: "使用桩计费",
    useSysCharging: "使用平台计费",
    useInputharging: "手动录入金额",
    amountPayable: "应付金额（THB）",
    countType: "计算公式：桩充电费总额/（平台充电费总额+占桩费总额）",
    payAmount: "支付总额（THB）"
  },
  orderDetails: {
    aorderDetailsTitle: "充电订单详情",
    chargeType: "充电类型",
    chargeStatus: "充电状态",
    chargingModel: "充电策略",
    chargeElect: "充电电量",
    chargeDuration: "充电时长",
    orderCheckDetails: "订单校验详情",
    chargeDataEchart: "充电数据",
    chargeMoneyEchart: "充电计费数据曲线",
    batteryEchart: "电池信息曲线",
    faultCode: "异常编码",
    faultName: "异常名称",
    faultDesc: "异常描述",
    userInfo: "用户信息",
    siteInfo: "站点信息",
    siteId: "站点 ID",
    pileInfo: "桩信息",
    rateInfo: "费用信息",
    errorHandle: "异常处理",
    billingMethod: "计费方式",
    operationTime: "操作时间",
    operationoOject: "操作对象",
    insertGun: "插枪",
    startCharging: "启动充电",
    endCharging: "结束充电",
    draw: "拔枪",
    outputVoltage: "输出电压",
    chargingPower: "充电功率",
    outputCurrent: "输出电流",
    demandVoltage: "需求电压",
    demandCurrent: "需求电流",
    cpVoltage: "CP 电压",
    chargerTemperature: "充电机温度",
    gunTemperature: "枪口温度",
    brmProtocol: "brm 协议版本",
    brmBatteryType: "brm 电池类型",
    brmBatteryCapacity: "brm 电池额定容量",
    brmRatedVoltage: "brm 额定总电压",
    BCPMaxVoltage: "BCP 单体最高电压",
    BCPMaxCurrent: "BCP 最高电流",
    BCPBatteryEnergy: "BCP 电池总能量",
    BCPMacVoltage: "BCP 最高充电电压",
    BCPMaxTemperature: "BCP 最高温度",
    BCPStartSOC: "BCP 开始 SOC",
    BSMMaxTemperature: "BSM 最高动力电池温度",
    BCSMaxBatteryVoltage: "BCS 最高单体电池电压"
  },
  offCardOrder: {
    cardPhysicalSn: "流水号",
    cardSn: "物理卡号",
    chargeMode: "充电方式",
    dealType: "订单状态",
    exportName: "离线卡订单",
    dl: "充电电量（度）",
    amount: "收入金额（THB）",
    service: "服务费（THB）",
    chargingTime: "充电时长",
    orderNumber: "订单数量（笔）",
    offCardNum: "离线卡数量（个）",
    chargingType: "充电方式"
  },
  offCardOrderDetails: {
    pageTitle: "充电订单详情"
  },
  operationData: {
    activeNum: "活跃人数",
    orderCount: "订单数量",
    chargeHours: "充电时长(h)",
    totalElec: "充电电量（度）",
    serviceAmount: "服务费（THB）",
    todayData: "今日数据",
    todayTotalAmount: "今日收入",
    todayOrderCount: "今日订单量",
    todayTotalElec: "今日充电量",
    todayDuration: "今日时长",
    todayActiveNum: "今日活跃人数",
    assets: "资产信息",
    noStaPkId: "请选择充电站",
    modalTab: "图表",
    modalTab2: "表格",
    fullName: "会员名称",
    phoneNo: "手机号",
    createTime: "注册时间",
    balanceAmount: "账号余额（THB）",
    chargeTimes: "充电次数",
    staDataChartTitle: "充电站数据统计",
    yAxisName: "总电量（度）/ 总金额（THB）",
    staDataDl: "总电量",
    staDataAmount: "总金额",
    pileChartTitle: "充电桩",
    pileChartAc: "交流桩",
    pileChartDc: "直流桩",
    pileTitle: "资产数据"
  },
  alarmEvent: {
    alarmTime: "告警时间",
    eventAmount: "事件总数",
    todayEvent: "今日事件",
    alarmRatio: "告警比例",
    alarmLevel: "告警级别",
    alarmType: "告警类型",
    equipmentAlarmAmountTop5: "设备故障告警次数 TOP5",
    stationAlarmAmountTop5: "站点告警次数 TOP5",
    equipmentSn: "设备 SN",
    stationName: "站点名称",
    quantity: "次数",
    faultDesc: "事件描述",
    recoverTime: "恢复时间",
    duration: "异常时长",
    alarmStatus: "当前状态",
    equipmentType: "设备类型"
  },
  siteMonitor: {
    province: "省",
    city: "市",
    type: "类型",
    power: "功率",
    equipmentAmount: "设备数量（个）",
    gun: "枪",
    number: "编号",
    voltage: "电压",
    current: "电流",
    chargeElect: "充电电量",
    totalPower: "累计充电量",
    thisPower: "当前输出功率",
    setPower: "设置输出功率",
    totalTimes: "累计充电次数（次）",
    totalHours: "累计充电时长",
    accountPkId: "充电账号",
    accountType: "账户类型",
    carVin: "车辆 VIN 码",
    chargedMinutes: "充电时长",
    chargingPower: "充电量",
    predictAmount: "充电金额（THB）",
    faultInfo: "故障信息",
    orderDetails: "订单详情"
  },
  pileInfo: {
    operationType: "营业类型",
    staStatus: "运营状态",
    pileList: "桩列表"
  },
  pileInfoDetail: {
    city: "城市",
    staAddress: "地址",
    position: "建设场所",
    staLat: "经纬度",
    staTypeName: "站点类型",
    fullName: "关联商户",
    tagInfoVos: "站点标签",
    commissioningDate: "投运时间",
    businessBeginHours: "开放时间",
    parkNum: "车位数量",
    serviceTel: "服务电话",
    phoneNo: "站点电话",
    hasFreePark: "是否免费停车费",
    yes: "是",
    no: "否",
    remarks: "温馨提示",
    feeName: "站点费率",
    DC: "直流桩",
    AC: "交流桩",
    oprDelayFeeInfos: "占桩费",
    delayFreeMinutes: "免费时长",
    staPics: "站点图片",
    staInfo: "充电桩信息",
    totalDev: "总设备",
    dcGunCount: "直流枪口",
    acGunCount: "交流枪口",
    tab1: "站点详情",
    tab2: "维护记录",
    tab3: "费率变更记录",
    price: "总价（THB/kWh）",
    manufacturerName: "设备商",
    ratedPower: "额定功率（kW）",
    delayUnit: "THB/分钟",
    reason: "原因",
    debuggingPeople: "调试人员",
    debuggingContent: "调试内容",
    oldFeeName: "旧费率",
    newFeeName: "新费率",
    replaceTime: "更换日期"
  },
  pileInfoEle: {
    addRateBtn: "增加费率模板",
    upRateBtn: "更换费率模板",
    delRateBtn: "删除费率模板",
    rateTpl: "费率模板",
    feeName: "模板名称",
    feeNamePl: "请输入模板名称",
    acRate: "交流桩费率",
    dcRate: "直流桩费率",
    delayRate: "占桩费率",
    delayFreeMinutes: "免费时长（分钟）",
    rate: "费率",
    elePriceList: "电价列表",
    slotFlag: "电价类型",
    slotElecPrice: "电价（THB/kWh）",
    slotServicePrice: "服务费（THB/kWh）",
    time: "时间段",
    slotDelayPrice: "费率（THB/分钟）",
    delRateConfirm: "确认删除当前电价吗？",
    ratePl: "请选择费率"
  },
  pileList: {
    batchStaBtn: "批量关联/解绑",
    batchLineBtn: "批量上线/下线",
    addBtn: "增加桩信息",
    deviceStatus: "充电桩状态",
    showQcode: "二维码",
    editGun: "编辑枪",
    showUnlock: "解锁",
    offLine: "离线",
    showFee: "下发电价",
    outPile: "迁出充电桩",
    unbind: "解绑",
    downQCode: "下发",
    staName: "所属站点",
    internalNumber: "站内编号",
    chargeGunInfoVoList: "电枪型号",
    parkNo: "车位号",
    gunStatus: "电枪状态",
    editPile: "编辑桩",
    issueSuccess: "下发二维码成功",
    showFeeConfirm: "确定下发电价吗?",
    showFeeSuccess: "下发电价成功",
    showUnlockConfirm: "确定解锁吗?",
    showUnlockSuccess: "解锁成功",
    unbindSuccess: "解绑站点成功！",
    moveInSta: "迁入的充电站",
    moveInStaPl: "请选择充电站",
    remarks: "备注"
  },
  addPile: {
    deviceType: "设备类型",
    deviceModelPkId: "设备型号",
    protocolPkId: "协议",
    remark: "备注",
    gunInfo: "枪口信息",
    info: "信息",
    addName: "新增充电桩",
    staNamePl: "所属站点必须选择",
    deviceTypePl: "设备类型必须选择",
    deviceModelPkIdPl: "设备型号必须选择",
    sn: "桩编号",
    snPl: "桩编号不能为空",
    snPl2: "桩编号必须为数字",
    snPl3: "桩编号必须为数字或者字母",
    pileNamePl: "桩名称不能为空",
    deviceStatusPl: "运营状态不能为空",
    protocolPkIdPl: "请选择协议主键",
    qrcode: "二维码",
    detailsName: "充电桩详情",
    updataName: "修改充电桩",
    charging: "充电中",
    inserted: "已插枪",
    fault: "故障",
    disable: "禁用",
    offLine: "离线",
    free: "空闲",
    full: "已充满",
    subscribe: "预约",
    offline: "下线",
    online: "上线"
  },
  splitSettlement: {
    shareSettlement: "分成结算",
    orderBreakdown: "订单分成明细",
    merchantName: "商户名称",
    chargingOrderNumber: "充电订单号",
    selectionTime: "选择时间",
    chargingStation: "充电站",
    chargeVolume: "充电量",
    connectionfee: "连接费",
    electricityBill: "电费",
    serviceCharge: "服务费",
    chargeableAmount: "应付充电金额（THB）",
    discountAmount: "优惠金额（THB）",
    totalAmountActuallyPaid: "实付总金额（THB）",
    partitionMethod: "分成方式",
    merchantIncome: "商户收入",
    operatorShare: "运营商分成",
    orderDate: "订单日期",
    orderTimeError: "订单时间不能为空，请选择",
    errorStartTimeEndTime: "开始时间不能晚于结束时间",
    contentConfirm: "确认选中此数据吗？",
    successfulOperation: "操作成功",
    daySettlementOrderNumber: "日结订单号",
    dailyStatementStatus: "日结单状态",
    settlementDate: "结算日期",
    numberOfOrders: "订单笔数",
    actualChargeAmount: "实付充电金额（THB）",
    merchantIncomeAmount: "商户收入金额（THB）",
    operatorShareAmount: "运营商分成金额（THB）",
    createTime: "生成日期",
    pleaseSelectTheGenerationDate: "请选择生成日期",
    createTimeError: "生成日期开始时间不能晚于结束时间",
    selectMonth: "请选择月结月份",
    confirmDate: "确认选中当前数据吗？",
    confirmGeneration: "确认要重新生成数据吗？",
    withdrawnDate: "确认要撤回选中的数据吗？",
    selectDate: "确认要对选中的数据进行操作吗？",
    selectDateToOperate: "请选择要进行操作的数据",
    deleteTitle: "作废原因",
    remarkPl: "请输入原因",
    supplement: "补单",
    orderNo: "选择日结订单号",
    orderNoPl: "请选择订单",
    staName: "充电站",
    settlementStatus: "核算状态",
    regenerate: "重新生成",
    allSettlement: "批量核算",
    settlement: "核算",
    errorInfo: "异常信息",
    accountingRecords: "核算记录",
    accountingRecordsStatus: "核算状态",
    accountingRecordsRepairStatus: "修复状态",
    accountingRecordsTime: "结算日期",
    initialAccounting: "初次核算",
    newAccounting: "最新核算",
    ComparisonResults: "对比结果差额",
    voidPl: "请选择要作废的结算单",
    voidSuccess: "结算单作废成功！",
    auditOrderPl: "请选择要审核结算单",
    auditOrder: "审核结算单",
    auditOrderSuccess: "结算单审核成功！",
    auditOrderConfirm: "审核后不能撤销，请谨慎操作"
  },
  withdrawal: {
    dataTitle1: "待提现（THB）",
    dataTitle2: "已提现（THB）",
    withdrawOrderStatus: "提现单状态",
    createTime: "生成日期",
    reviewDate: "审核日期",
    withdrawOrderTemplate: "提现单模板",
    withdrawOrderNumber: "提现单号",
    withdrawalAmount: "提现金额",
    transferFee: "手续费",
    actualWithdrawalAmount: "实际提现金额",
    withdrawalAdd: "新增提现单",
    preview: "预览",
    resubmit: "重新提交",
    withdraw: "撤回",
    annex: "附件",
    transferAmount: "实际提现金额",
    completeTime: "完成提现日期",
    orderStatusDesc: "提现单状态",
    withdrawWithdrawal: "撤回提现单",
    withdrawWithdrawalConfirm: "确定撤回提现单?",
    withdrawWithdrawalSuccess: "撤回提现单成功"
  },
  withdrawalTemplate: {
    orderNo: "提现订单号",
    order: "提现单",
    payee: "收款方",
    payer: "付款方",
    remarks: "备注",
    remarks1:
      "1. 充电金额为用户通过运营商 APP 在商户所辖充电站充电产生的金额；",
    remarks2: "2. 实际提现金额 = 本期提现金额 - 转账手续费；",
    remarks3: "3. 转账手续费为线下转账费用；",
    cashExplain: "提现说明",
    cashExplain1:
      "1. 账单核对无误后，申请提现方盖章确认后将账单邮寄至付款方公司，或者通过电子邮件方式发送。付款方会在收到后3-5个工作日内完成线下对公或对私转账。",
    cashExplain2: "2. 签字盖章后，即代表认同本次提现结算。",
    cashMch: "提现商户（盖章）：",
    sign: "授权代表签字：",
    time: "日期：",
    download: "下载证书",
    cashInfo: "提现信息",
    merchantName: "提现商户",
    staNameList: "所属充电站",
    previousBalance: "上期提现后余额",
    totalAmount: "本期提现金额",
    serviceCharges: "转账手续费",
    transferAmount: "实际提现金额",
    collectionInfo: "收款信息",
    mchContactPerson: "商户联系人",
    mchPhoneNumber: "商户电话",
    bankAccountName: "公司名称",
    collectionAcc: "收款账户",
    bankDeposit: "开户银行",
    bankAccountNo: "收款账号",
    payerInfo: "付款方信息",
    oprName: "付款方名称",
    contacts: "联系人",
    telephone: "联系电话",
    invoiceType: "发票类型",
    openInfo: "开票信息",
    companyName: "公司名称",
    taxId: "税号",
    payerBankAccountNo: "账号",
    registerAddress: "收件地址",
    no: "无"
  },
  withdrawFormAdd: {
    pageAdd: "新增提现单",
    pageUpdata: "重新提交提现单",
    invoiceType: "是否开发票",
    totalAmount: "提现金额",
    availableAmount: "可提现金额",
    allWithdraw: "全部提现",
    minWithdraw: "最低提现金额",
    serviceCharges: "转账手续费",
    transferAmount: "实际提现金额",
    collectionInfo: "收款信息",
    bankAccountName: "账户名称",
    bankDeposit: "开户银行",
    bankAccountNo: "银行账号",
    amountNullPl: "请输入提现金额",
    amountErrorPl: "提现金额必须大于 0 且小数位不超过两位",
    amountMin: "一次性提现金额不能少于",
    amountMax: "提现金额不能超过可提现金额"
  },
  header: {
    out: "退出登录",
    outConfirm: "确定要退出登录吗？",
    order: "待处理异常订单",
    goClick: "点击跳转",
    unit: "条",
    outTime: "登录过期，请重新登录"
  },
  cashTopUp: {
    cashTopUp: "现金充值",
    topUp: "充值",
    orderNo: "充值订单号",
    userName: "用户名",
    phone: "手机号",
    email: "邮箱",
    transactionTime: "充值时间",
    userEmail: "用户邮箱",
    userPhone: "用户手机号",
    amount: "金额（THB）",
    amountTip: "请输入金额",
    topUpConfirmation: "现金充值确认",
    topUpAmount: "充值金额",
    topUpAmountUnit: "充值金额（THB）",
    confirmUserTip: "确定给该用户充值？",
    accountDoesNotExist: "用户账户不存在"
  },
  feedback: "反馈",
  language: "语言",
  saveFailed: "保存失败",
  emailBandTips: "该邮箱已关联充电卡，每个邮箱只能关联一张充电卡。",
  emailNoRegTips: "该邮箱地址尚未注册，请确认是否将其注册为App用户"
};
